import React from 'react'
import User from '../components/user'
import { logOut, loginWithGoogle, loginWithFacebook } from '../firebase/login'


export const UserContainer = () =>
  <User logOut={logOut} loginWithGoogle={loginWithGoogle} loginWithFacebook={loginWithFacebook} />



export default UserContainer